import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDown({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.149 18.99l-.067.007-.1.003-.071-.004-.111-.016-.112-.03-.111-.043-.098-.053-.095-.067a1.01 1.01 0 01-.09-.08l-6-6a1 1 0 011.32-1.497l.093.083L11 15.587V6a1 1 0 01.884-.993L12 5a1 1 0 01.993.884L13 6v9.586l4.293-4.293a1 1 0 011.32-.083l.094.083a1 1 0 01.084 1.32l-.084.094-6 6-.046.044-.065.053-.112.072-.112.053-.106.035-.117.025z"
        fill={color}
      />
    </svg>
  )
}

export default SvgDown
